<template>
  <div
    class="text-left pt-1 pb-2 info-list main__light_green "
    :class="details ? 'details' : 'nodetails' "
    data-qa="tender-info-block">
    <div
      v-if="!full"
      class="flex flex-between mx-4">
      <slot name="title">
        <div class="info-bar__title">
          {{ $t('Tenders.AboutTender') }}
        </div>
      </slot>
      <div
        class="info-bar__action"
        data-qa="info-bar-action">
        <slot name="action"/>
      </div>
    </div>
    <slot/>
    <CreatedInOldAccountChip
      v-if="tender && tender.hasRoute"
      class="mx-4"
      mode="top"
      :tender-id="tender.tenderId"/>
    <slot name="after_name"/>
    <div
      v-if="tender && tender.tenderId"
      class="mx-4 py-4"
      data-qa="block-status">
      <div class="h9-label">
        {{ $t('Purchasing.Status') }}
      </div>
      <StatusChip
        key-name="id"
        :status="getStatus(tender)"
        value-name="title"/>
    </div>
    <KeyValue
      v-if="previousFrameTender"
      :caption="$t('Tenders.TenderOnBasisOfFramework')"
      class="mx-4 mb-3 mt-3"
      data-qa="block-tender-on-basis-of-framework">
      <router-link
        class="text-decoration-underline font-size-14"
        data-qa="href-tenderitem-frameworkBase"
        :to="{name: 'tenderitem', params: { id: previousFrameTender.tenderId, org: $route.params.org}}">
        #{{ previousFrameTender.tenderNumber }} {{ previousFrameTender.title || 'frameworkBase' }}
      </router-link>
    </KeyValue>
    <KeyValue
      v-for="item in topItems"
      :key="item.dataQa"
      :caption="item.caption"
      class="mx-4 mb-3 mt-3"
      :data-qa="item.dataQa"
      :value="item.value"/>
    <KeyValue
      v-if="!bidding_type_WithoutPublication"
      :caption="$t('Tenders.AcceptanceOfProposals')"
      class="mx-4 mb-3 mt-3"
      data-qa="block-acceptance-of-proposals">
      <TenderDateTo
        class="font-size-14"
        format_to
        :item="tender"
        necessarily/>
    </KeyValue>
    <KeyValue
      v-if="deliveryPeriodTo || deliveryPeriodFrom"
      :caption="$t('Tenders.DeliveryTimeTitle')"
      class="mx-4 mb-3 mt-3"
      data-qa="block-aelivery-time-title">
      <div
        class="font-size-14"
        data-qa="info-bar-delivery-period">
        {{ deliveryPeriodFrom ? $t('Common.DateFrom') : '' }} {{ formatDate(deliveryPeriodFrom) }}
        {{ deliveryPeriodTo ? $t('Common.DateTill') : '' }} {{ formatDate(deliveryPeriodTo) }}
      </div>
    </KeyValue>
    <template v-if="details || !short">
      <KeyValue
        :caption="$t('Tenders.AdditionalDescription')"
        class="mx-4 mb-3 mt-3"
        data-qa="block-additional-description">
        <div
          class="font-size-14"
          data-qa="info-bar-description"
          style="white-space: break-spaces;">
          {{ tender.tenderDescription || tender.description || '–' }}
        </div>
      </KeyValue>
      <KeyValue
        v-if="prolongation_rule"
        :caption="$t('Tenders.AutoContinuation')"
        class="mx-4 mb-3 mt-3"
        data-qa="block-auto-continuation">
        <div>
          <div
            class="font-size-14"
            data-qa="info-bar-prolongation-rule">
            {{ prolongation_rule.title || prolongation_rule.name || $t('Common.NoData') }}
          </div>
          <div class="font-size-12 pa-0 ma-0 opacity-8">
            {{ $t('Tenders.ExtensionRuleWorks') }}
            {{ prolongation_rule.startTimeNextDay }}
            {{ $t('Common.till') }}
            {{ prolongation_rule.endTimeCurrentDay }}
          </div>
        </div>
      </KeyValue>
      <KeyValue
        v-if="available_prolongation_rule"
        :caption="$t('Tenders.AutoContinuationUnderOtherConditions')"
        class="mx-4 mb-3 mt-3"
        data-qa="block-auto-continuation-under-other-conditions">
        <div>
          <div
            class="font-size-14"
            data-qa="info-bar-available-prolongation-rule">
            {{ available_prolongation_rule.ruleTitle }}
          </div>
          <div class="font-size-12 pa-0 ma-0 opacity-8">
            {{ available_prolongation_rule.ruleDescription }}
          </div>
        </div>
      </KeyValue>
      <BudgetInfo :tender="tender"/>
      <KeyValue
        :caption="$t('Tenders.Organizer')"
        class="mx-4 mb-3 mt-3"
        data-qa="block-organizer">
        <div>
          <div
            class="font-size-14"
            data-qa="info-bar-tender-organization-title">
            {{ (tender.organizer ? tender.organizer.title : tender.organizerName) || '–' }}
          </div>
          <div
            v-if="tender.organizer"
            class="font-size-12 pa-0 ma-0 opacity-8"
            data-qa="info-bar-tender-organization-usreou">
            {{ tender.organizer.usreou }}
          </div>
        </div>
      </KeyValue>
      <KeyValue
        v-if="tender && tender.contactPerson"
        :caption="$t('Tenders.ContactPerson')"
        class="mx-4 mb-3 mt-3"
        data-qa="block-contactPerson">
        <ContactPerson
          :data-qa="'info-bar-tender-contactPerson'"
          :item="tender.contactPerson"/>
      </KeyValue>
      <template v-if="tender && tender.additionalContactPersons && tender.additionalContactPersons.length">
        <div
          v-for="(item, itemIndex) in tender.additionalContactPersons"
          :key="item.contactId"
          class="mx-4 mb-3 mt-3"
          :data-qa="`info-bar-additionalContact-${itemIndex}`">
          <div
            class="font-size-12 pa-0 ma-0 opacity-8"
            data-qa="info-bar-tender-organization-usreou">
            {{ tender.additionalContactPersons.length > 1 ? $t('Tenders.AdditionalContactPersons') : $t('Tenders.AdditionalContactPerson') }}
          </div>
          <ContactPerson
            :data-qa="`info-bar-additionalContact-${itemIndex}`"
            :item="item"/>
        </div>
      </template>
      <template v-if="details && !bidding_type_WithoutPublication">
        <div class="mx-4 mb-3 mt-3">
          <div class="h5-headline">
            {{ $t('Tenders.Additionally') }}
          </div>
        </div>
        <KeyValue
          v-if="tender && tender.biddingType && tender.biddingType.groupedLotsEnabled"
          :caption="$t('Tenders.ForAllLotInGroup')"
          class="mx-4 mb-3 mt-3">
          <div
            class="font-size-14"
            data-qa="info-bar-tender-all-lots">
            {{ !tender || !tender.tenderId ? '-' : (tender.bidOnAllLotInGroup ? $t('Tenders.Yes') : $t('Tenders.No')) }}
          </div>
        </KeyValue>
        <KeyValue
          v-else
          :caption="$t('Tenders.ForAllLots')"
          class="mx-4 mb-3 mt-3"
          data-qa="block-for-all-lots">
          <div
            class="font-size-14"
            data-qa="info-bar-tender-all-lots">
            {{ !tender || !tender.tenderId ? '-' : (tender.bidOnAllLots || tender.allLotsRequiredBid ? $t('Tenders.Yes') : $t('Tenders.No')) }}
          </div>
        </KeyValue>
        <KeyValue
          v-for="item in detailItems"
          :key="item.dataQa"
          :caption="item.caption"
          class="mx-4 mb-3 mt-3"
          :data-qa="item.dataQa"
          :value="item.value"/>
        <div
          v-if="additional_fields && additional_fields.length"
          class="additional-fields"
          data-qa="additional-fields">
          <div class="additional-fields_header h5-headline pl-5 pr-4 pb-4 text-start">
            {{ $t('AdditionalFields.AdditionalFields') }}
          </div>
          <div
            v-for="(item, index) in additional_fields"
            :key="index"
            class="additional-fields__item additional-field py-3"
            :data-qa="`additional-field-${item.id}`">
            <div class="additional-field__subtitle h9-label px-4 text-start">
              {{ item.caption }}
            </div>
            <div class="additional-field__title black--text h7-text px-4 text-start">
              <template v-if="item.type === 'URL'">
                <a
                  :key="item.id + '-' + item.lotId"
                  :href="item.value"
                  rel="nofollow"
                  target="_blank">{{ item.value }}</a>
              </template>
              <template v-else>
                {{ item.value || '–' }}
              </template>
            </div>
          </div>
        </div>
      </template>
    </template>
    <sButton
      v-if="!full"
      class="h9-text-bold pa-1 ml-3"
      :rounded="false"
      small
      type="text"
      @click="details = !details">
      {{ details ? $t('Application.HideDetails') : $t('Application.SeeDetails') }}
      <sIcon
        class="ml-1"
        :rotate="details ? '-180' : '0'"
        size="10"
        type="arrow"/>
    </sButton>
  </div>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'
import ContactPerson from 'components/tenders/ContactPerson.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import BudgetInfo from 'components/tenders/all tenders/BudgetInfo.vue'
import TenderDateTo from 'components/tenders/all tenders/TenderDateTo.vue'
import CreatedInOldAccountChip from 'components/tenders/CreatedInOldAccountChip.vue'

import moment from 'moment'
import { tenderMixin, modalMixin, holidaysMixin } from 'mixins'

export default {
  name: 'infoBar',
  mixins: [ tenderMixin, modalMixin, holidaysMixin ],
  data() {
    return {
      details: false,
      prolongation_rules: [],
      available_prolongation_rules: [],
    }
  },
  watch: {
    'tender.prolongationRule': {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$store.dispatch('setProlongationRule')
            .then(res => {
              this.prolongation_rules = res
            })
        }
      }
    }
  },
  mounted() {
    if (this.full) { this.details = true }
  },
  props: {
    tender: Object,
    short: Boolean,
    full: Boolean,
  },
  computed: {
    topItems() {
      const t = this.tender
      const schedule = t?.tenderPublishedSchedule
      return [
        {
          if: schedule?.scheduledDate,
          caption: this.$t('Tenders.ScheduledPublication'),
          value: this.formatDateTime(schedule?.scheduledDate),
          dataQa: 'block-scheduled-publication',
        },
        {
          if: schedule?.previousMailing !== null && schedule?.previousMailing !== undefined,
          caption: this.$t('Tenders.PreviousMailing'),
          value: this.yesNo(schedule?.previousMailing),
          dataQa: 'block-previous-mailing',
        },
        {
          if: t?.biddingType,
          caption: this.$t('Tenders.TenderType'),
          value: t?.biddingType?.title || t?.biddingType?.titleRu || '–',
          dataQa: 'block-tender-type',
        },
        {
          if: t?.auctionPeriod,
          caption: this.$t('Tenders.Auction'),
          value: this.auction_period_to,
          dataQa: 'block-auction',
        },
      ].filter(item => 'if' in item ? !!item.if : true)
    },
    detailItems() {
      const t = this.tender
      return [
        {
          caption: this.$t('Tenders.mandatoryFullBid'),
          value: this.yesNo(t.mandatoryFullBid),
          dataQa: 'block-mandatoryFullBid',
        },
        {
          caption: this.$t('Tenders.AttachmentWhenSubmitting'),
          value: t.requiedAttachments ? this.$t('Tenders.Necessarily') : this.$t('Tenders.Optional'),
          dataQa: 'block-attachment-when-submitting',
        },
        {
          if: this.$can('hide', 'BestPriceBeforeBidding') && !t?.biddingType?.isRating && !t?.biddingType?.isAnalysisMarket,
          caption: this.$t('Tenders.HideBestBidPrice'),
          value: this.yesNo(t.hideBestPrice),
          dataQa: 'block-hide-best-bid-price',
        },
        {
          caption: this.$t('Tenders.ApplicationBased'),
          value: this.yesNo(t.applicationBased),
          dataQa: 'block-application-based',
        },
        {
          if: t.isUrgent,
          caption: this.$t('Tenders.UrgentPurchase'),
          value: this.$t('Tenders.Yes'),
          dataQa: 'block-urgent-purchase',
        },
        {
          if: this.bidding_type_IsSale,
          caption: this.$t('Tenders.AllowedIndividualsParticipation'),
          value: this.yesNo(t.individualsAllowed),
          dataQa: 'block-allowed-individuals-participation',
        },
        {
          if: !t.allowParticipantBidCancellation,
          caption: this.$t('Tenders.CancellationBidprohibited'),
          value: this.$t('Tenders.Yes'),
          dataQa: 'block-cancellation-bid-prohibited',
        },
        {
          if: t.inviteFilter && t.inviteFilter !== 'ALL',
          caption: this.$t('Tenders.TypeInvitedMembers'),
          value: t.inviteFilter ? this.$t(`Tenders.ResidentType.${t.inviteFilter}`) : '',
          dataQa: 'block-invite-filter',
        },
      ].filter(item => 'if' in item ? !!item.if : true)
    },
    additional_fields() {
      let fields = this.tender.additional_fields || []
      return fields
        .filter(f => f.bindingLevel == 'TENDER')
        .map(field => {
          const type = field?.typeId || field?.type?.typeId
          let value = field.fieldValues.find(values => values.entityKey == this.tender.tenderId)?.value,
            formatted = ''
          if ( type == 'DATE_TIME' ) {
            formatted = this.formatBy(value, 'DD.MM.YYYY')
          } else if (type == 'CHECKBOX') {
            formatted = eval(value) ? this.$t('Tenders.Yes') : this.$t('Tenders.No')
          } else {
            formatted =  value
          }
          return {
            ...field,
            type,
            value: formatted
          }
        })
        .sort((a,b) => a.order - b.order)
    },
    deliveryPeriodFrom() {
      return this.tender.deliveryPeriod?.startDate || this.tender.deliveryPeriodFrom
    },
    deliveryPeriodTo() {
      return this.tender.deliveryPeriod?.endDate || this.tender.deliveryPeriodTo
    },
    previousFrameTender() {
      if ( this.tender?.biddingType?.isFrameAuction && this.tender?.previousTender?.tenderType == 'FRAME_TENDER' ) {
        return this.tender?.previousTender
      }
      return null
    },
    bidding_type_IsSale() {
      return this.tender?.biddingType?.isSale
    },
    bidding_type_WithoutPublication() {
      return this.tender?.biddingType?.withoutPublication
    },
    prolongation_rule() {
      return this.prolongation_rules?.find(elem => {
        return this.tender?.prolongationRule == elem.code
      })
    },
    available_prolongation_rule() {
      return this.tender?.autoProlongationRules && this.tender?.autoProlongationRules[0]
    },
    auction_period_to() {
      return this.formatDateTo(this.tender?.auctionPeriod?.endDate)
    },
  },
  methods: {
    yesNo(val) {
      return val ? this.$t('Tenders.Yes') : this.$t('Tenders.No')
    },
    formatDate(value) {
      return value && moment(value).isValid() ? moment(value).format('DD MMMM YYYY') : ''
    },
    formatDateTime(value) {
      return value && moment(value).isValid() ? moment(value).format('DD MMMM YYYY, HH:mm') : ''
    },
  },
  components: {
    KeyValue,
    StatusChip,
    BudgetInfo,
    TenderDateTo,
    ContactPerson,
    CreatedInOldAccountChip
  }
}
</script>
<style lang="scss">
.info-bar{
  &__title {
    text-align: left;
    margin: auto 0;
    white-space: normal;
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.01em;
    padding-left: 4px;
  }
  &__action {
    margin-left: 16px;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    align-self: center;
    padding: 0;
    display: inline-flex;
    min-width: 24px;
  }
}
.additional-field__subtitle {
  max-width: 100%;
}
.info-list {
  overflow: auto;
  width: 100%;
  max-height: 100%;
  &.details {
    height: 100%;
    & + .comment-block, & + #history-tabs {
      &, & + .close-changing-winners {
        display: none !important;
      }

    }
  }
  &, & .sticky {
    background-color: var(--v-secondary__green_chosen-base);
  }
  &.nodetails {
    min-height: min-content;
    height: min-content;
  }
  &.sticky {
    position: sticky;
    top: -10px;
    z-index: 20;
  }
  .additional-field__title {
    white-space: pre-line;
  }
}
</style>
